// extracted by mini-css-extract-plugin
module.exports = {"buttons":"UpgradeAccountModal_buttons__2A-tR"};